module.exports = __webpack_public_path__ + "static/dc-sao-paulo-3-8b6d9343a1078b7a552a2940c5c6348c.jpg";